/*
 * Puschies — weiches Einblenden der Bilder 1:1 wie CallMePuppy (assets/cmp-image-reveal.js): Sobald ein Bild ins
 * Blickfeld kommt UND geladen ist, blendet es 300 ms ein und zoomt dabei von 105 % auf 100 %
 * (Zoom nur, wenn der Rahmen überstehende Kanten abschneidet — sonst nur Einblenden).
 * Betrifft nur lazy geladene Bilder in <main>; das Hero-Bild oben (eager) bleibt sofort sichtbar.
 * Versteckt werden die Bilder per CSS nur, wenn <html> die Klasse .p-reveal trägt — die setzt
 * das Inline-Script im <head>, samt Notfall-Timeout, falls diese Datei nicht lädt.
 * Nachgeladene Bilder (Karussell-Klone, Editor) erfasst ein MutationObserver. Ohne Library.
 */
(() => {
  const root = document.documentElement;
  if (!root.classList.contains('p-reveal')) return;
  window.pImageReveal = true;

  const SELECTOR = 'img[loading="lazy"]:not(.p-in)';
  const TIMING = { duration: 300, easing: 'ease' };
  const main = document.querySelector('main') || document.body;

  const show = (img) => {
    if (img.classList.contains('p-in')) return;
    img.classList.add('p-in');
    const parent = img.parentElement;
    const clips = parent && getComputedStyle(parent).overflow !== 'visible';
    img.animate(clips ? { opacity: [0, 1], transform: ['scale(1.05)', 'scale(1)'] } : { opacity: [0, 1] }, TIMING);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(({ isIntersecting, target }) => {
        if (!isIntersecting) return;
        observer.unobserve(target);
        if (target.complete && target.naturalWidth) {
          show(target);
        } else {
          target.addEventListener('load', () => show(target), { once: true });
          target.addEventListener('error', () => target.classList.add('p-in'), { once: true });
        }
      });
    },
    { rootMargin: '0px 0px -40px 0px' }
  );

  const watch = (scope) => scope.querySelectorAll(SELECTOR).forEach((img) => observer.observe(img));
  watch(main);

  new MutationObserver((records) => {
    records.forEach((record) =>
      record.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches(SELECTOR)) observer.observe(node);
        else watch(node);
      })
    );
  }).observe(main, { childList: true, subtree: true });
})();
